import { CreatorGrowthLoopInputs } from './creator-growth-loop';
import { CreatorScoreModel } from './creator-score.model';

/** Outcomes that feed exposure can influence in the product loop. */
export type FeedImpactOutcome = 'engagement' | 'follows' | 'earnings';

/**
 * Describes how feed exposure maps into growth loop inputs and score dimensions.
 * Mapping structure only — no execution logic.
 */
export interface FeedImpactChannel {
  readonly outcome: FeedImpactOutcome;
  readonly growthLoopInput: keyof CreatorGrowthLoopInputs;
  readonly scoreDimension: keyof CreatorScoreModel;
  readonly description: string;
}

/** How feed exposure influences engagement, follows, and earnings. */
export interface FeedImpactModel {
  readonly exposureToEngagement: FeedImpactChannel;
  readonly exposureToFollows: FeedImpactChannel;
  readonly exposureToEarnings: FeedImpactChannel;
}

export const FEED_IMPACT_MODEL: FeedImpactModel = {
  exposureToEngagement: {
    outcome: 'engagement',
    growthLoopInput: 'engagement_received',
    scoreDimension: 'engagementScore',
    description: 'Feed visibility drives audience interaction with creator content',
  },
  exposureToFollows: {
    outcome: 'follows',
    growthLoopInput: 'follows_received',
    scoreDimension: 'visibilityScore',
    description: 'Feed discovery surfaces creators and increases follow graph weight',
  },
  exposureToEarnings: {
    outcome: 'earnings',
    growthLoopInput: 'purchases_generated',
    scoreDimension: 'monetizationScore',
    description: 'Feed exposure to products and creators influences purchase intent',
  },
};
